export default __webpack_public_path__ + "static/media/landing_cloud_storage.a0e88ba8.jpg";